import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ChevronRightIcon from '../../icons/ChevronRightIcon';

export default function ActionButton({
  href, label, faIcon, target = '_self', ...restProps
}) {
  return (
    <Link
      href={href}
      className="btn btn-outline-secondary border-1 d-flex align-items-center w-100 bg-body text-body px-4 py-3"
      target={target}
      {...restProps}
    >
      <span className="d-flex flex-grow-1 align-items-center">
        <FontAwesomeIcon icon={faIcon} width={32} height={32} className="text-primary" />
        <span className="ms-3">{label}</span>
      </span>
      <ChevronRightIcon />
    </Link>
  );
}
